module.exports = __webpack_public_path__ + "static/media/ball_5_8.7eb44a33.mp3";